var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { legalDepositsPeriodicalLibrariesIdVolumes, legalDepositsPeriodicalLibrariesIdVolumesIdIssues, legalDepositsPeriodicalLibrariesIdVolumesIdDepositRecords, legalDepositsPeriodicalLibrariesIdVolumesNext, legalDepositsPeriodicalLibrariesIdVolumesPrevious, legalDepositsPeriodicalVolumesId, legalDepositsPeriodicalVolumesIdWindowPreview, legalDepositsPeriodicalIssuesIdLibraryStatus, legalDepositsPeriodicalIssuesId, legalDepositsPeriodicalLibrariesIdSpecialIssues, legalDepositsPeriodicalLibrariesIdIrregularIssues, legalDepositsPeriodicalLibrariesIdRegularIssues, legalDepositsPeriodicalsIdEndPublication, legalDepositsPeriodicalsIdReopenPublication, legalDepositsPeriodicalIssuesMerge, legalDepositsPeriodicalIssuesIdUnmerge, legalDepositsPeriodicalIssuesIdLabel, legalDepositsPeriodicalIssuesIdLabelReset, } from "../types/apiPaths";
export var fetchVolumes = function (kyInstance, plId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsPeriodicalLibrariesIdVolumes(plId), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var fetchVolumeMatrix = function (kyInstance, plId, volumeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .get(legalDepositsPeriodicalLibrariesIdVolumesIdIssues(plId, volumeId), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var generateAdjacentVolume = function (kyInstance, plId, direction) { return __awaiter(void 0, void 0, void 0, function () {
    var path;
    return __generator(this, function (_a) {
        path = direction === "next"
            ? legalDepositsPeriodicalLibrariesIdVolumesNext(plId)
            : legalDepositsPeriodicalLibrariesIdVolumesPrevious(plId);
        return [2 /*return*/, kyInstance.post(path, { headers: getHeaders() }).json()];
    });
}); };
export var generateVolumeRecordsForLibrary = function (kyInstance, plId, volumeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsPeriodicalLibrariesIdVolumesIdDepositRecords(plId, volumeId), { headers: getHeaders() })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var previewVolumeWindow = function (kyInstance, volumeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .post(legalDepositsPeriodicalVolumesIdWindowPreview(volumeId), {
                json: payload,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var updateVolumeWindow = function (kyInstance, volumeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .put(legalDepositsPeriodicalVolumesId(volumeId), {
                json: payload,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var deleteVolume = function (kyInstance, volumeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.delete(legalDepositsPeriodicalVolumesId(volumeId), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var changeIssueLibraryStatus = function (kyInstance, issueId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalIssuesIdLibraryStatus(issueId), { json: payload, headers: getHeaders() })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var updateIssueGlobal = function (kyInstance, issueId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalIssuesId(issueId), {
                    json: payload,
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var createSpecialIssue = function (kyInstance, plId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .post(legalDepositsPeriodicalLibrariesIdSpecialIssues(plId), {
                json: payload,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var createIrregularIssue = function (kyInstance, plId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .post(legalDepositsPeriodicalLibrariesIdIrregularIssues(plId), {
                json: payload,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var createRegularIssue = function (kyInstance, plId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .post(legalDepositsPeriodicalLibrariesIdRegularIssues(plId), {
                json: payload,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var endPublication = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalsIdEndPublication(titleId), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var reopenPublication = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalsIdReopenPublication(titleId), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var mergeIssues = function (kyInstance, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsPeriodicalIssuesMerge, {
                    json: payload,
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var unmergeIssue = function (kyInstance, issueId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsPeriodicalIssuesIdUnmerge(issueId), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var updateMergeLabel = function (kyInstance, issueId, label) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalIssuesIdLabel(issueId), {
                    json: { label: label },
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var resetIssueLabel = function (kyInstance, issueId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsPeriodicalIssuesIdLabelReset(issueId), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var deletePeriodicalIssue = function (kyInstance_1, issueId_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1, issueId_1], args_1, true), void 0, function (kyInstance, issueId, renumberFollowing) {
        var query;
        if (renumberFollowing === void 0) { renumberFollowing = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = renumberFollowing ? "?renumberFollowing=true" : "";
                    return [4 /*yield*/, kyInstance.delete("".concat(legalDepositsPeriodicalIssuesId(issueId)).concat(query), {
                            headers: getHeaders(),
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
